import { render, staticRenderFns } from "./tips1-toast.vue?vue&type=template&id=bada0366&scoped=true&"
import script from "./tips1-toast.vue?vue&type=script&lang=js&"
export * from "./tips1-toast.vue?vue&type=script&lang=js&"
import style0 from "./tips1-toast.vue?vue&type=style&index=0&id=bada0366&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bada0366",
  null
  
)

export default component.exports